/**
 * VDB Framework — API Facade
 * Build 003 / Commit 003.4
 */
(function (window) {
  "use strict";

  const VDB = window.VDB = window.VDB || {};
  const C = window.VDBConfig || {};

  function provider() {
    const selected = VDB.providers?.get?.(C.provider);
    if (!selected) throw new Error(`VDB provider "${C.provider}" is not registered.`);
    return selected;
  }

  VDB.api = {
    provider,
    health: () => provider().health(),
    getMakes: () => provider().getMakes(),
    getModels: make => provider().getModels(make),
    getYears: (make, model) => provider().getYears(make, model),
    getEngines: (make, model, year) => provider().getEngines(make, model, year),
    resolveVehicle: params => provider().resolveVehicle(params),
    clearCache: () => provider().clearCache?.(),
    diagnostics: () => provider().diagnostics?.() || {}
  };
})(window);
